import React, { PureComponent } from 'react';

import ListingsFilters from './ListingFilters';
import Auth from '../../../libs/Auth';

class ListingsView extends PureComponent {
  constructor(props){
    super(props);
    this.state = {
      expanded: {}
    }
  }
  toggle(id){
    const { expanded } = this.state;
    this.setState({
      expanded: {
        ...expanded,
        [id]: !expanded[id]
      }
    });
  }
  render() {
    let {
      listings,
      page,
      nextPage,
      previousPage,
      importListingCSV,
    } = this.props;

    return (
      <div className="admin-listings-view">
        <ListingsFilters {...this.props} />
        <div className="page">
          <div className="actions">
            <button onClick={() => importListingCSV()} className="button" type="button">Import Listings</button>
          </div>
          <table>
            <thead>
            <tr>
              <th>ID</th>
              <th>SKU</th>
              <th>Price</th>
              <th>Amazon Price</th>
              <th>Account</th>
              <th>Name</th>
              <th>day</th>
              <th>week</th>
              <th>month</th>
              <th>total</th>
              <th></th>
            </tr>
            </thead>

            {listings.map((listing, i)=>(
              <tbody key={listing._id}>
              <tr className={i%2 ? 'even' : 'odd'}>
                <td><a href={listing.url} target="_blank">{listing.itemId}</a></td>
                <td>{listing.SKU}</td>
                <td>{listing.currentPrice}</td>
                <td>{listing.amazonPrice}</td>
                <td>{listing.ebayAccountUserId}</td>
                <td>{listing.title}</td>
                <td>{Math.round(listing.lastDayTransactionsTotal * 100) / 100}$</td>
                <td>{Math.round(listing.lastWeekTransactionsTotal * 100) / 100}$</td>
                <td>{Math.round(listing.lastMonthTransactionsTotal * 100) / 100}$</td>
                <td>{Math.round(listing.transactionsTotal * 100) / 100}$</td>
                <td>
                  <div className="action-buttons">
                    <button onClick={() => this.toggle(listing._id)}><i className="fi-arrows-out size-18"></i> view more</button>
                  </div>
                </td>
              </tr>
              {this.state.expanded[listing._id] && (
                <tr>
                  <td colSpan="10">
                    <img src={listing.image} alt="image"/>
                    <h5>Transactions</h5>
                    <table>
                      <thead>
                        <tr>
                          <th>Status</th>
                          <th>Date</th>
                          <th>id</th>
                          <th title="Quantity purchased">#</th>
                          <th>Paid</th>
                          <th>Adjustment</th>
                          <th>Final Value Fee</th>
                          <th>Transaction Price</th>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listing.transactions.map((item, i)=>(
                          <tr key={i}>
                            <td>{item.completeStatus}</td>
                            <td>{item.createdDate}</td>
                            <td>{item.transactionID}</td>
                            <td>{item.quantityPurchased}</td>
                            <td>{Math.round(item.convertedAmountPaid * 100) / 100}$</td>
                            <td>{Math.round(item.convertedAdjustmentAmount * 100) / 100}$</td>
                            <td>{Math.round(item.finalValueFee * 100) / 100}$</td>
                            <td>{Math.round(item.transactionPrice * 100) / 100}$</td>
                            <td>{item.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <ul>

                    </ul>
                  </td>


                </tr>
              )}
              </tbody>
            ))}
            <tbody>
            <tr>
              <td colSpan="13">
                <ul className="pagination">
                  <li className={page <= 1 ? 'pagination-previous disabled' : 'pagination-previous'}>
                    {page > 1  ? (
                      <a onClick={e=>{
                        e.preventDefault();
                        previousPage();
                      }}>Previous</a>
                    ) : 'Previous'}

                  </li>
                  <li>{page}</li>
                  <li className="pagination-next">
                    <a onClick={e=>{
                      e.preventDefault();
                      nextPage();
                    }}>Next</a>
                  </li>
                </ul>
              </td>
            </tr>

            </tbody>
          </table>
        </div>

      </div>
    );
  }
}

export default ListingsView;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Listings/Listings.view.js